import { jsx as c } from "react/jsx-runtime";
import l from "@mui/material/SvgIcon";
import * as t from "react";
import { forwardRef as m } from "react";
const a = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "7 7 18 18", ...e }, /* @__PURE__ */ t.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.393 19.857a5.47 5.47 0 0 1-5.464-5.464 5.47 5.47 0 0 1 5.464-5.465 5.47 5.47 0 0 1 5.464 5.465 5.47 5.47 0 0 1-5.464 5.464m10.217 2.87-4.132-4.133-.02.02a7.36 7.36 0 0 0 1.328-4.221 7.393 7.393 0 1 0-7.393 7.392c1.57 0 3.024-.493 4.221-1.328l-.02.02 4.132 4.133c.26.26.601.39.942.39s.682-.13.942-.39c.52-.52.52-1.364 0-1.884", clipRule: "evenodd" })), f = /* @__PURE__ */ m(({ size: e = "inherit", sx: o, ...r }, n) => {
  const i = typeof o == "function" ? o : {
    fontSize: e,
    ...o
  };
  return /* @__PURE__ */ c(l, {
    ...r,
    ref: n,
    component: a,
    inheritViewBox: !0,
    sx: i
  });
});
f.displayName = "svg_search";
export {
  f as default
};
